// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reelpay-modal-shadow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.3);
  transition: all 0.3s;
  width: 100vw;
  height: 100vh;
}
.reelpay-modal {
  position: absolute;
  left: 50%;
  bottom: 50%;
  transform: translate3d(-50%, 50%, 0);
  margin: auto;
  opacity: 0;
  animation-duration: 150ms;
  animation-fill-mode: forwards;
}
.reelpay-modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 18px;
  padding: 24px;
  max-height: 70vh;
  font-family: Darker Grotesque;
}
.reelpay-close {
  position: absolute;
  top: 24px;
  right: 20px;
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.reelpay-modal.cardFadeIn {
  animation-name: cardFadeIn;
}
.reelpay-modal.cardFadeOut {
  animation-name: cardFadeOut;
}
@keyframes cardFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes cardFadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@media screen and (max-width: 452px) {
  .reelpay-close {
    top: 20px;
    right: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Modal/style.css"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,oCAAA;EACA,oBAAA;EACA,YAAA;EACA,aAAA;AACJ;AAEA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,oCAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;EACA,6BAAA;AAAJ;AAGA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,6BAAA;AADJ;AAIA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAFJ;AAKA;EACI,0BAAA;AAHJ;AAMA;EACI,2BAAA;AAJJ;AAOA;EACI;IACI,UAAA;EALN;EAQE;IACI,UAAA;EANN;AACF;AASA;EACI;IACI,UAAA;EAPN;EAUE;IACI,UAAA;EARN;AACF;AAWA;EACI;IACI,SAAA;IACA,WAAA;EATN;AACF","sourcesContent":[".reelpay-modal-shadow {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: rgba(0, 0, 0, .3);\n    transition: all .3s;\n    width: 100vw;\n    height: 100vh;\n}\n\n.reelpay-modal {\n    position: absolute;\n    left: 50%;\n    bottom: 50%;\n    transform: translate3d(-50%, 50%, 0);\n    margin: auto;\n    opacity: 0;\n    animation-duration: 150ms;\n    animation-fill-mode: forwards;\n}\n\n.reelpay-modal-content {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    background-color: #fff;\n    border-radius: 18px;\n    padding: 24px;\n    max-height: 70vh;\n    font-family: Darker Grotesque;\n}\n\n.reelpay-close {\n    position: absolute;\n    top: 24px;\n    right: 20px;\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n}\n\n.reelpay-modal.cardFadeIn {\n    animation-name: cardFadeIn\n}\n\n.reelpay-modal.cardFadeOut {\n    animation-name: cardFadeOut\n}\n\n@keyframes cardFadeIn {\n    from {\n        opacity: 0\n    }\n\n    to {\n        opacity: 1\n    }\n}\n\n@keyframes cardFadeOut {\n    from {\n        opacity: 1\n    }\n\n    to {\n        opacity: 0\n    }\n}\n\n@media screen and (max-width: 452px) {\n    .reelpay-close {\n        top: 20px;\n        right: 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
